import React from 'react';
import './InlineAlert.css';

export default function InlineAlert({
  title,
  message,
  tone = 'error',
  actionLabel,
  onAction,
  compact = false,
}) {
  if (!title && !message) return null;

  return (
    <div className={`inline-alert inline-alert--${tone}${compact ? ' inline-alert--compact' : ''}`} role={tone === 'error' ? 'alert' : 'status'}>
      <div className="inline-alert__content">
        {title && <div className="inline-alert__title">{title}</div>}
        {message && <div className="inline-alert__message">{message}</div>}
      </div>
      {actionLabel && onAction && (
        <button type="button" className="inline-alert__action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}
